/**
 * Centralized URL path constants for React Router.
 * Every screen has exactly one canonical URL slug.
 * Keep these in sync with SCREENS in src/constants/navigation.ts.
 */

export const PATHS = {
  // ── Pre-auth ──────────────────────────────────────────
  ONBOARDING:       '/onboarding',
  LOGIN:            '/login',
  SIGNUP:           '/signup',
  PROFILE_SETUP:    '/setup',

  // ── Main tabs ─────────────────────────────────────────
  DISCOVER:         '/discover',
  DISCOVER_COUNTRY: '/discover/:country',
  YAP_TAB:          '/yaptab',
  YAP_TAB_FRIENDS:  '/yaptab/friends',
  EXPLORE:          '/explore',
  CHAT:             '/chat',

  // ── Profile ───────────────────────────────────────────
  PROFILE:          '/profile',
  PROFILE_EDIT:     '/profile/edit',
  PROFILE_YAPS:     '/profile/yaps',
  PROFILE_FLAGS:    '/profile/flags',
  FRIEND_PROFILE:   '/profile/:userId',
  FRIEND_YAPS:      '/profile/:userId/yaps',

  // ── App screens ───────────────────────────────────────
  NOTIFICATIONS:    '/notifications',
  SETTINGS:         '/settings',
  SAFETY:           '/safety',
  BLOCKED_USERS:    '/safety/blocked',
  MUTED_WORDS:      '/safety/muted',

  // ── Content detail ────────────────────────────────────
  YAP_DETAIL:       '/yap/:yapId',
  SHOUT_DETAIL:     '/shout/:shoutId',
  TRIBE_GROUP:      '/tribe/:tribeId',
  HISTORY_FORUM:    '/forum/:forumId',
  DIRECT_MESSAGE:   '/messages/:userId',
  ROOM:             '/room/:roomId',
  EVENT_DETAILS:    '/event/:eventId',

  // ── Explore sub-screens ───────────────────────────────
  ALL_TRIBES:       '/explore/tribes',
  ALL_FORUMS:       '/explore/forums',
  ALL_HISTORY:      '/explore/history',
  ALL_COUNTRIES:    '/explore/countries',
  COUNTRY_SELECTION:'/country-selection',

  // ── Business profiles ─────────────────────────────────
  // MY_BUSINESS is the owner's dashboard and is auth-gated.
  // BUSINESS_PROFILE is deliberately NOT: it is the public share link, viewable
  // logged out, with the Firestore rule scoping that read to active profiles.
  MY_BUSINESS:      '/my-business',
  BUSINESS_BUILDER: '/my-business/build/:registrationId',
  BUSINESS_PROFILE: '/business/:profileId',

  // ── Misc ──────────────────────────────────────────────
  REPORT:           '/report',
  LEGAL:            '/legal/:type',
  STORE:            '/store',
  WATCHER_DASHBOARD:'/watcher',

  // ── Root redirect target ──────────────────────────────
  ROOT:             '/',
} as const;

export type PathName = typeof PATHS[keyof typeof PATHS];

/** Build a concrete path by substituting :param placeholders. */
export function buildPath(
  template: string,
  params: Record<string, string | number> = {}
): string {
  let path = template;
  for (const [key, value] of Object.entries(params)) {
    path = path.replace(`:${key}`, String(value));
  }
  return path;
}
